exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?minimize!vuesax/dist/vuesax.css"), "");
exports.i(require("-!../../../node_modules/css-loader/index.js?minimize!material-icons/iconfont/material-icons.css"), "");

// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-b278e2e4!./~/vue-loader/lib/selector.js?type=styles&index=0!./app/components/ia/IaApp.vue
// module id = 247
// module chunks = 0